/**
 * Created by torugo on 28/04/2017.
 */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  }            from "@angular/core";
import { CommonModule }        from "@angular/common";
import { ReactiveFormsModule,FormsModule } from "@angular/forms";
import {RouterModule} from "@angular/router";
import { TextMaskModule } from 'angular2-text-mask';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { OfficeComponent } from "./office.component";
import { ChartModule }            from 'angular2-highcharts';
//import {SafePipe} from './safe-pipe';
@NgModule({
    imports : [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      RouterModule,
      TextMaskModule,
      ChartModule,
      NguiAutoCompleteModule,
    ],
    declarations : [
      OfficeComponent
    ],
    providers : [
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class OfficeModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/office-screens/office.module.ts